'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Logo } from '@/components';
import { analytics } from '@/utils/analytics';
import { GTM_SOURCES } from '@/constants/gtm';
import { NAV_LINKS_ALL, filterByPhase } from '@/constants/nav';
import { primaryCTA } from '@/libs/cta';
import styles from './Navbar.module.scss';

const NAV_LINKS = filterByPhase(NAV_LINKS_ALL);
const normPath = (p) => (p === '/' ? '/' : p.replace(/\/$/, ''));

export default function Navbar() {
  const pathname = normPath(usePathname() ?? '/');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => setMenuOpen(false), [pathname]);

  // Bloquea el scroll del body con el menú móvil abierto.
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <nav className={styles.nav}>
        <div className={styles.inner}>
          <Link
            href="/"
            className={styles.logo}
            aria-label="Gómez & Thomas — inicio"
          >
            <Logo dark />
          </Link>

          <ul className={styles.links}>
            {NAV_LINKS.map(({ label, href }) => (
              <li key={href}>
                <Link
                  href={href}
                  className={normPath(href) === pathname ? styles.active : ''}
                >
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                href={primaryCTA.href}
                className={styles.cta}
                onClick={() => analytics.contactRequest(GTM_SOURCES.NAVBAR)}
              >
                Contacto
              </Link>
            </li>
          </ul>

          <button
            className={`${styles.burger} ${menuOpen ? styles.open : ''}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Panel móvil — fuera de <nav> para que `position: fixed` se ancle al
          viewport (el backdrop-filter del nav lo contendría si fuera hijo). */}
      {menuOpen && (
        <div className={styles.mobileMenu} id="mobile-menu">
          <nav className={styles.mobileLinks} aria-label="Navegación móvil">
            {NAV_LINKS.map(({ label, href }) => (
              <Link
                key={href}
                href={href}
                className={normPath(href) === pathname ? styles.active : ''}
              >
                {label}
              </Link>
            ))}
            <Link
              href={primaryCTA.href}
              className={styles.contact}
              onClick={() =>
                analytics.contactRequest(GTM_SOURCES.NAVBAR_MOBILE)
              }
            >
              Contacto
            </Link>
          </nav>
        </div>
      )}
    </>
  );
}
